import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { loggedInUser } from "../../services/auth.handlers";

const initialState = {
  loading: false,
  status: null,
  authToken: null,
  userData: null,
  error: null,
};
export const loggedIn = createAsyncThunk("Auth/Login", async (data, { dispatch }) => {
  const { email, password, callback } = data;
  const res = await loggedInUser({ email, password });
  if (res.status) {
    localStorage.removeItem('@submenu');
    
    // Execute callback if provided (for direct navigation)
    if (callback && typeof callback === 'function') {
      callback();
    }
  }
  return res;
});

export const loggedOut = createAsyncThunk("Auth/LogOut", async () => {
  localStorage.removeItem('@submenu');
  return { status: true };
});

const AuthSlice = createSlice({
  name: "Auth",
  initialState,
  reducers: {
    checkUserAuth(state) {
      state.loading = false;
      state.authToken = null;
      state.status = null;
      state.userData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loggedIn.pending, (state) => {
        state.loading = true;
      })
      .addCase(loggedIn.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        if (payload.status) {
          state.authToken = payload.data.data;
          state.userData = payload.data.profile;
          state.error = null;
        } else {
          state.error = "Invalid Credentials";
        }
      })
      .addCase(loggedIn.rejected, (state, { error }) => {
        state.loading = false;
        state.error = error.message || "Login failed";
      })
      .addCase(loggedOut.pending, (state) => {
        state.loading = true;
      })
      .addCase(loggedOut.fulfilled, (state) => {
        state.loading = false;
        state.authToken = null;
        state.status = null;
        state.userData = null;
      })
      .addCase(loggedOut.rejected, (state) => {
        state.loading = false;
      });
  },
});
export const { checkUserAuth } = AuthSlice.actions;

export default AuthSlice.reducer;
